export default __webpack_public_path__ + "static/media/orangeOrbPullQuote1Mobile.baba313b.svg";